import cdivimg from './images/404-header.webp';
import '@aofl/picture';
import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
<aofl-img class="mb-5" src="${cdivimg}" alt="404 image" width="336" height="138"></aofl-img>

<h1 class="display-4 mb-5 text-center">${until(ctx.__('<tt-rWlFJs29>', 'Page not found'))}</h1>

<p class="text-center">${until(ctx.__('<tt-dhlc/RL/>', 'Sorry, but the page you are looking for is not found.<br>Try refreshing the page or go back to the Homepage.'))}</p>
`;
